<template>
  <div class="ui-tabs"><slot /></div>
</template>

<script setup lang="ts">
import { provide, ref, toRef, useId, watch } from 'vue'
import { TABS, type TabsVariant } from './context'

const props = withDefaults(defineProps<{ defaultValue?: string; variant?: TabsVariant }>(), {
  defaultValue: '',
  variant: 'segmented',
})

const model = defineModel<string | undefined>({ default: undefined })
const current = ref(model.value ?? props.defaultValue)

watch(model, (value) => {
  if (value !== undefined) current.value = value
})

provide(TABS, {
  current,
  variant: toRef(props, 'variant'),
  base: useId(),
  select(value: string) {
    current.value = value
    model.value = value
  },
})
</script>
